import Layout from "@/components/Layout";
import dynamic from 'next/dynamic';

const pages = [
    {
        name: 'Franchise Us',
        with_banner: 1,
        banner_title: 'Get in touch',
        banner_description: 'OUR FRIENDLY TEAM WILL BE HAPPY TO ANSWER QUESTIONS OR INQUIRIES.',
        url: 'franchise-us',
        component: 'FranchiseUs'
    },
    {
        name: 'Be a fleet partner',
        with_banner: 1,
        banner_title: 'Be a fleet partner',
        banner_description: 'OUR FRIENDLY TEAM WILL BE HAPPY TO ANSWER QUESTIONS OR INQUIRIES.',
        url: 'be-a-fleet-partner',
        component: 'BeAPartner'
    },
    {
        name: 'Contact Us',
        with_banner: 1,
        banner_title: 'Contact Us',
        banner_description: 'OUR FRIENDLY TEAM WILL BE HAPPY TO ANSWER QUESTIONS OR INQUIRIES.',
        url: 'contact-us',
        component: 'ContactUs'
    },
    {
        name: 'Privacy Policy',
        with_banner: 0,
        banner_title: 'Privacy Policy',
        banner_description: '',
        url: 'privacy-policy',
        component: 'PrivacyPolicy'
    },
    {
        name: 'Terms of service',
        with_banner: 0,
        banner_title: 'Terms of service',
        banner_description: '',
        url: 'terms-of-service',
        component: 'TermsOfService'
    },
];

export default function Page({ selected_page, sources }){
    const CustomPage = dynamic(
            () => import('@/components/CustomPages').then((page) => {
                return(
                    page[selected_page.component]
                );
            })
        );
    return(
        <Layout pageTitle={`Rapidé - ${selected_page.name}`}>
            <div className={`relative top-0 max-w-full mx-auto ${selected_page.with_banner == 1 ? 'lg:mt-0 md:mt-0 sm:mt-[93px] mt-[93px]' : ''}`}>
                <div className="">
                    {selected_page.with_banner == 1 ? (
                        <div className="relative bg-cover bg-no-repeat bg-fixed sm:bg-center bg-[center_top_4.84rem] bg-[url('/assets/images/be-a-partner-bg.webp')] lg:h-[550px] md:h-[450px] sm:h-[350px] h-[200px]">                        
                            <div className='absolute sm:bottom-20 bottom-5 lg:left-28 left-5 bg-black/75 lg:w-5/12 sm:w-5/6 w-11/12'>
                                <div className='absolute top-16 -left-20 bg-rapide-yellow h-1 w-28'></div>
                                <h1 className='sm:text-3xl text-xl text-white tracking-widest pl-12 pb-4 sm:pt-12 pt-4 uppercase font-bold'>{selected_page.banner_title}</h1>
                                <h1 className='text-lg text-white tracking-widest pl-12 sm:pb-12 pb-4 capitalize'>{selected_page.banner_description}</h1>
                            </div>
                        </div>
                    ) : (
                        <div className="relative lg:h-[150px] md:h-[110px] sm:h-[101px] h-[93px] bg-black"></div>
                    )}
                    <CustomPage sources={sources}/>
                </div>
            </div>
        </Layout>
    );
}

export async function getServerSideProps({params}) {
    const getSources = await fetch(`${process.env.API_URL}/sources`);
    const sources = await getSources.json();

    const selected_page = pages.find((page) => {
        if(page.url == params.name) return page;
    });
    if (!selected_page) {
        return {
            notFound: true,
        }
    }

    return {
        props: { selected_page, sources }, // will be passed to the page component as props
    }
}